import { fabric } from 'fabric';
import { CanvasDataTypes, clipObject } from '../../../utils';
import { CustomFabricObject, FabricObject } from '../../../global-types/canvas';
import { addPhotozoneImageMoveConstraint } from '../../../features/card-editor/utils/add-photozone-image-move-constraint';
import { getPhotoZoneSettings } from '../../card-editor/card-editor-utils';

/**
 * Handles photozone-related logic during canvas JSON loading.
 * - Caches photozone groups by zoneId in `myPhotozone`
 * - Adds movement constraints for PhotoZoneImage when force-fill is enabled
 */
type LoadPhotozoneObjectsProps = {
  fabricItem: FabricObject;
  myPhotozone: Map<string, fabric.Group>;
  IS_FORCE_FILL_ENABLED: boolean;
  currentCardFace: { zones: Record<string, any> };
  cardState: any;
};

export const loadPhotozoneObjects = ({
  fabricItem,
  myPhotozone,
  IS_FORCE_FILL_ENABLED,
  currentCardFace,
  cardState,
}: LoadPhotozoneObjectsProps): void => {
  // Cache photozone group by zoneId
  if (fabricItem.name?.startsWith('photozone')) {
    myPhotozone.set(String((fabricItem as CustomFabricObject).zoneId), fabricItem as unknown as fabric.Group);
  }

  // Fabric does not serialize onSelect, so restore the photo-zone selection guard.
  if (fabricItem.data?.type === CanvasDataTypes.PhotoZoneImage) {
    (fabricItem as fabric.Image).onSelect = () => false;
  }

  // Add movement constraint if this is a photozone image
  if (fabricItem.data?.type === CanvasDataTypes.PhotoZoneImage && IS_FORCE_FILL_ENABLED) {
    const photozoneIndex = fabricItem.data.photoZoneId.slice(-1);

    // Find photoZone by matching fabricItem's photoZoneId with the photoZone's name
    let photoZone = Array.from(myPhotozone.values()).find((zone) => zone.name === fabricItem.data.photoZoneId);

    if (!photoZone) {
      photoZone = getPhotoZoneSettings(currentCardFace.zones[`${photozoneIndex}`], photozoneIndex, cardState);
    }

    if (!photoZone) {
      throw new Error('PhotoZone not found for adding movement constraint.');
    }
    addPhotozoneImageMoveConstraint(fabricItem as fabric.Image, photoZone);
  }

  if (fabricItem.data?.type === 'userUploadedImage') {
    const photoZone = myPhotozone.get(String((fabricItem as CustomFabricObject).imgToZoneId));
    if (photoZone) {
      clipObject(photoZone, fabricItem);
    }
  }
};
